import React, { FC } from 'react';
import { Redirect } from 'react-router-dom';
import { isMobile, isDesktop } from 'react-device-detect';
import { logOutAction, clearLoginAction } from '../redux/actions/login';
import { connect } from 'react-redux';
import DashboardNotAvailable from '../screens/Products/Plural/DashboardNotAvailable';
import { UiRoutes } from '../lib/constants';
import { getSelectedProduct } from '../lib/helper';
import RedirectToLogin from './RedirectToLogin';

const CommonLayout: FC<{
  component: FC;
  path: string;
  exact?: boolean;
  loginState;
  isAdmin: boolean;
  logOutAction: CallableFunction;
  clearLoginAction: CallableFunction;
}> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { path, exact, ...rest } = props;

  const { isUserAuthenticated, isWaitingForAPIResponse } = props.loginState;

  return !isWaitingForAPIResponse ? (
    isUserAuthenticated ? (
      isDesktop && !isMobile ? (
        props.isAdmin && !props.loginState.MerchantId ? (
          <Redirect to={UiRoutes.UNIFIED_MERCHANT_LISTING} />
        ) : getSelectedProduct() ? (
          <Redirect to={UiRoutes.OVERVIEW} />
        ) : null
      ) : (
        <DashboardNotAvailable
          isAdmin={props.isAdmin}
          onClickHandler={
            props.loginState.showOtpScreen
              ? props.clearLoginAction
              : props.logOutAction
          }
        />
      )
    ) : (
      <RedirectToLogin />
    )
  ) : (
    <React.Fragment></React.Fragment>
  );
};

const mapStateToProps = ({ loginReducer }) => ({
  loginState: loginReducer.loginState,
  isAdmin: loginReducer.loginState.isAdmin,
});

export default connect(mapStateToProps, { logOutAction, clearLoginAction })(
  CommonLayout
);
